module.exports = __webpack_public_path__ + "static/screenshot-dark-533466c1907d36bbc8eb0963a05f673c.png";